// extracted by mini-css-extract-plugin
module.exports = {"title":"Form_title__1r_z5","form":"Form_form__29Tli","wrap":"Form_wrap__1bE7x","btn":"Form_btn__V1GOz","link":"Form_link__32581","additional":"Form_additional__1rl5L"};